import ReactQuill from "react-quill";
import React, { RefObject, useEffect, useRef, useState } from "react";

import "react-quill/dist/quill.snow.css";
import { Button, Form, Modal, Select, Skeleton } from "antd";
import { getSettingsPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";

const EditorInput = ({
  onChange,
  defaultValue,
  value: controlledValue,
  useVariables = false,
  variables,
  onBlur,
  readOnly = false,
  disabled = false,
}: {
  onChange: (value: string) => void;
  defaultValue?: string;
  value?: string;
  useVariables?: boolean;
  variables?: any[];
  onBlur?: () => void;
  readOnly?: boolean;
  disabled?: boolean;
}) => {
  const [modalVariablesOpen, setModalvariablesOpen] = useState(false);
  const [variableSelected, setVariableSelected] = useState<string>("");
  const [value, setValue] = useState<string>(controlledValue ?? defaultValue ?? "");
  const quillRef: RefObject<ReactQuill> = useRef(null);

  const { locale } = useLocale();
  const [settingsPage, setSettingsPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getSettingsPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setSettingsPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          setSettingsPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => {
      cancel = true;
    };
  }, [locale]);

  // const varButton = document.createElement("button");
  // varButton.innerHTML = "variables";
  // varButton.id = "var-button";
  // varButton.addEventListener("click", () => setModalvariablesOpen(true));
  // varButton.style.width = "70px";
  // varButton.style.background = "#cedff3";

  // useEffect(() => {
  //   if (useVariables) {
  //     const toolbar = document.getElementsByClassName("ql-toolbar")[0];
  //     toolbar.appendChild(varButton);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [useVariables]);
  // Si está en modo controlado (value prop), usar ese valor; si no, usar defaultValue
  useEffect(() => {
    if (controlledValue !== undefined) {
      setValue(controlledValue);
    } else if (defaultValue !== undefined) {
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlledValue, defaultValue]);

  const getOptionVariables = () => {
    const result: any[] = [];
    if (variables && variables?.length > 0)
      variables?.forEach((element) => result.push(...element.options));
    return result;
  };

  const handleOkVariables = () => {
    if (variableSelected !== "")
      quillRef.current?.editor?.insertText(
        quillRef.current?.editor.getLength() - 1,
        `{{${variableSelected}}}`,
      );

    setModalvariablesOpen(false);
    setVariableSelected("");
  };
  const isReadOnly = readOnly || disabled;

  return (
    <>
      {useVariables && !isReadOnly && (
        <Button
          onClick={() => setModalvariablesOpen(true)}
          style={{
            width: 70,
            background: "#cedff3",
            margin: 5,
            position: "absolute",
            top: "-42px",
            right: 0,
          }}
        >
          {settingsPage?.template_detail?.variable || "Variables"}
        </Button>
      )}
      <ReactQuill
        theme="snow"
        ref={quillRef}
        readOnly={isReadOnly}
        modules={{
          toolbar: isReadOnly ? false : [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["link", "image"],
            ["clean"],
          ],
        }}
        value={value}
        style={{ backgroundColor: isReadOnly ? "#f5f5f5" : "white" }}
        onBlur={onBlur}
        onChange={(value) => {
          if (!isReadOnly) {
            setValue(value);
            value !== undefined ? onChange(value) : null;
            if (onBlur) onBlur();
          }
        }}
      />
      <Modal
        closable={false}
        open={modalVariablesOpen}
        onOk={handleOkVariables}
        okText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.template_detail?.insert_button || "Insertar"}
        onCancel={() => setModalvariablesOpen(false)}
        cancelText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.template_detail?.cancel_button || "Cancelar"}
        style={{ maxWidth: 450 }}
      >
        <Form.Item name="variable" label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.template_detail?.insert_variable || "Variable a insertar"}>
          <Select
            onChange={(e) => setVariableSelected(e)}
            options={getOptionVariables()}
            allowClear
            value={variableSelected}
            placeholder={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.template_detail?.variable || "Variable"}
          />
        </Form.Item>
      </Modal>
    </>
  );
};

export default EditorInput;
